<template>
    <li class="flex items-center justify-between gap-4 px-6 py-5 hover:bg-blue-dark hover:text-white cursor-pointer" @click="$emit('click')">
        <div class="min-w-0">
            <div class="flex items-center gap-3">
                <p class="truncate text-base font-medium">{{ label }}</p>
                <span v-if="badge" class="inline-flex items-center rounded-full bg-sky-100 px-2 py-0.5 text-xs font-semibold text-sky-700 ring-1 ring-inset ring-sky-200">
                    {{ badge }}
                </span>
            </div>
            <p v-if="sub" class="mt-1 text-sm text-green">{{ sub }}</p>
        </div>

        <div class="text-right">
            <p class="text-base font-semibold">{{ price }}</p>
            <p v-if="note" class="text-xs text-slate-500">{{ note }}</p>
        </div>
    </li>
</template>

<script>
export default {
    name: 'PriceRow',
    props: {
        label: { type: String, required: true },
        sub: { type: String, default: '' },
        price: { type: String, required: true },
        note: { type: String, default: '' },
        badge: { type: String, default: '' }
    }
};
</script>
